<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-8">
        <div class="card">
          <div class="card-body text-center">
            <div class="mb-3">
              <img
                :src="urlImage + user_profile.avatar"
                class="mr-0 rounded-circle avatar-xl"
                alt="user-pic"
                v-if="user_profile.avatar"
              />
              <img
                src="@/assets/images/users/avatar-10.jpg"
                class="mr-3 rounded-circle avatar-xl text-white"
                alt="user-pic"
                v-else
              />
            </div>
            <div>
              <b-button class="btn btn-sm" variant="light" @click="editImages()"
                ><i class="fas fa-edit"></i>
                {{ $t("user-management.change-image") }}
              </b-button>
            </div>
            <div class="pt-4">
              <table class="table-profile table text-left">
                <thead>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.name") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        :placeholder="$t('user-management.name')"
                        v-model="user_profile.name"
                        :class="{
                          'is-invalid':
                            submitted && $v.user_profile.name.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.user_profile.name.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.user_profile.name.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.username") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        id="validationCustom02"
                        type="text"
                        class="form-control"
                        :placeholder="$t('user-management.username')"
                        v-model="user_profile.username"
                        :class="{
                          'is-invalid':
                            submitted && $v.user_profile.username.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.user_profile.username.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.user_profile.username.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.email") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        id="validationCustom03"
                        type="email"
                        class="form-control"
                        :placeholder="$t('user-management.email')"
                        v-model="user_profile.email"
                        :class="{
                          'is-invalid':
                            submitted && $v.user_profile.email.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.user_profile.email.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.user_profile.email.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("user-management.role") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        type="text"
                        class="form-control bg-light"
                        value="Admin"
                        readonly
                        v-if="user_profile.role == 'admn'"
                      />
                      <input
                        type="text"
                        class="form-control bg-light"
                        value="this.$t('dashboards.analyst')"
                        readonly
                        v-else-if="user_profile.role == 'anly'"
                      />
                      <input
                        type="text"
                        class="form-control bg-light"
                        :value="this.$t('dashboards.verifier')"
                        readonly
                        v-else-if="user_profile.role == 'verf'"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("table.created_at") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        type="text"
                        class="form-control bg-light"
                        :value="formatDate(user_profile.created_at)"
                        readonly
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">
                      <b>{{ $t("table.updated_at") }}</b>
                    </td>
                    <td width="70%">
                      <input
                        type="text"
                        class="form-control bg-light"
                        :value="formatDate(user_profile.update_at)"
                        readonly
                      />
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="text-right mr-2">
              <router-link to="/profile" class="mr-1">
                <b-button class="btn" variant="danger"> Cancel </b-button>
              </router-link>
              <b-button class="btn" variant="success" @click="updatedProfile">
                <b-spinner v-if="loading" label="Loading ..." small></b-spinner>
                <span v-if="!loading" class="d-none d-sm-inline-block">
                  Update
                </span>
                <span v-if="loading"> Loading.. </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="ref-modal-edit"
      :id="'modal-edit-images'"
      centered
      :title="$t('button.update')"
      title-class="font-18"
      hide-footer
      @ok="updateImagesProfile($event)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group text-center">
            <img
              :src="urlImage + user_profile.avatar"
              class="avatar-xl rounded-circle mr-4"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">New Image</label>
            <b-form-file
              :state="true"
              :placeholder="$t('form.choose')"
              :drop-placeholder="$t('form.drop')"
              @change="ImageTarget"
              accept="image/*"
            ></b-form-file>
          </div>
        </div>
        <div class="col-md-12">
          <div class="text-right">
            <b-button
              class="mt-3 mr-1"
              @click="$bvModal.hide('modal-edit-images')"
              variant="danger"
              >{{ $t("button.cancel") }}</b-button
            >
            <b-button
              class="mt-3 mr-1"
              @click="updateImagesProfile"
              variant="success"
              >{{ $t("button.save") }}</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import { revenueChart } from "./data-profile";
import Stat from "@/components/widgets/stat";
import { required } from "vuelidate/lib/validators";
import { userService } from "@/helpers/authservice/user.service";
import Vue from "vue";

export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      revenueChart: revenueChart,
      title: "Profile",
      image_avatar: "",
      submitted: false,
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          href: "/profile",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      loading: false,
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        created_at: "",
        updated_at: "",
      },
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Upload Valid",
          value: "15",
        },
        {
          icon: "bx bx-hourglass",
          title: "Upload Pending",
          value: "4",
        },
        {
          icon: "bx bx-x-circle",
          title: "Upload Not Valid",
          value: "2",
        },
      ],
    };
  },
  validations: {
    user_profile: {
      name: { required },
      email: { required },
      username: { required },
    },
  },

  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let ferr = 0;
      UserService.profileUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let val = response.data.data;
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },
    updatedProfile(e) {
      let ferr = 0;
      this.submitted = true;
      this.$v.$touch();
      if (
        this.user_profile.username == "" ||
        this.user_profile.email == "" ||
        this.user_profile.name == ""
      ) {
        e.preventDefault();
      } else {
        this.loading = true;
        const data = {
          name: this.user_profile.name,
          username: this.user_profile.username,
          email: this.user_profile.email,
        };
        UserService.changeProfile(data)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.updatedProfile();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              let val = response.data.data;
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.user_profile.id_user = val.id_user;
              this.user_profile.username = val.username;
              this.user_profile.email = val.email;
              this.user_profile.name = val.name;
              this.user_profile.role = val.role ?? "-";
              this.user_profile.avatar = val.avatar ?? "";
              this.user_profile.last_login = val.last_login ?? "-";
              this.user_profile.created_at = this.formatDate(val.created_at);
              this.user_profile.updated_at = this.formatDate(val.updated_at);
              this.loading = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.updatedProfile();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.loading = false;
              }
            }
          });
      }
    },
    ImageTarget(evt) {
      this.image_avatar = evt.target.files[0];
    },
    updateImagesProfile() {
      let ferr = 0;
      const formImages = new FormData();
      formImages.append("avatar", this.image_avatar, this.image_avatar.name);
      UserService.changeAvatar(formImages)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updatedProfile();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.getUser();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$v.$reset();
            this.$bvModal.hide("modal-edit-images");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateImagesProfile();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },
    editImages() {
      this.$bvModal.show("modal-edit-images");
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
};
</script>      